////////////////////
const template = /*html*/ `


<div :class="['c-tile-product', {'-sale': isSale}]">
    <div class="c-tile-product_img">

        <div class="c-tile-product_tags">
            <div>
                <span class="c-tag -warning" v-if="!isAvailable">
                    <span class="c-tag_label">
                        {{ notAvailableLabel }}
                    </span>
                </span>
                <span class="c-tag" v-else-if="isNew">
                    <span class="c-tag_label">
                        {{ newLabel }}
                    </span>
                </span>

                <span class="c-tag -sale" v-if="isSale">
                    <span class="c-tag_label">
                        {{ saleLabel }}
                    </span>
                </span>
            </div>
        </div>

        <img
            class="c-figure_image || o-lazy_image || c-tile-product_alternative-image"
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
            alt=""
            data-src=""
            width="500"
            height="500"
            v-if="hasAlternativeImage"
            ref="alternativeImage"
        >

        <figure class="c-figure">
            <span class="c-figure_inner || o-lazy">
                <img
                    ref="image"
                    class="c-figure_image || o-lazy_image is-inview"
                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
                    data-src=""
                    alt="{{ title }}"
                    width="500"
                    height="500"
                >
            </span>
        </figure>

        <a :href="productUrl" class="c-tile-product_link">
            <span class="u-screen-reader-text">
                {{ goToProductLabel }}
            </span>
        </a>

        <div class="c-tile-product_button" v-if="canBeAddedToCart && isAvailable">
            <button
                class="c-button -white || c-tile-product_button_add"
                :aria-label="addToCartLabel"
                type="button"
                @click="onAddToCart"
            >
                <span class="c-button_label">{{ addToCartLabel }}</span>
            </button>
        </div>

        <div class="c-tile-product_button" v-else>
            <a
                :href="productUrl"
                class="c-button -white || c-tile-product_button_add"
                :aria-label="goToProductLabel"
                tabindex="-1"
            >
                <span class="c-button_label">{{ goToProductLabel }}</span>
            </a>
        </div>
    </div>
    <div class="c-tile-product_content">
        <div class="c-tile-product_content_inner">
            <h3 class="c-tile-product_content_title">
                {{ title }}
            </h3>
        </div>
        <div class="c-tile_product_content_price">
            <span class="c-tile_product_content_compare-price" v-if="isSale">{{ currentCompareAtPrice }}</span>
            <span><span v-if="priceRange.minVariantPrice.amount < priceRange.maxVariantPrice.amount">{{ fromProductLabel }} </span>{{ currentPrice }}</span>
        </div>
        <a :href="productUrl" class="c-tile-product_link" tabindex="-1">
            <span class="u-screen-reader-text">
                {{ goToProductLabel }}
            </span>
        </a>
    </div>
</div>
`;


////////////////////
// Scripts
////////////////////
import { format_price } from "../../utils/cart-utils";
import { lazyLoadImage } from "../../utils/image";

const IMAGE_WIDTH = 500;
const IMAGE_HEIGHT = 500;

export default function VueProductRecommendationsItem(moduleInstance) {

    Vue.component("product-recommendations-item", {

        template,

        props: {
            title: {
                type: String,
                required: true
            },
            images: {
                type: Array,
                default: () => []
            },
            handle: {
                type: String,
                required: true
            },
            createdAt: {
                type: String,
                required: true
            },
            priceRange: {
                type: Object,
                default: () => {}
            },
            compareAtPriceRange: {
                type: Object,
                default: () => {}
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            availableForSale: {
                type: Boolean,
                default: false
            },
            notAvailableLabel: {
                type: String,
                required: true
            },
            newLabel: {
                type: String,
                required: true
            },
            saleLabel: {
                type: String,
                required: true
            },
            addToCartLabel: {
                type: String,
                required: true
            },
            goToProductLabel: {
                type: String,
                required: true
            },
            fromProductLabel: {
                type: String,
                required: true
            },
            variantsObj: {
                type: Object,
                default: () => {}
            },
            currentLangCode: {
                type: String,
                required: true
            },
            customAlternativeImage: {
                required: true
            }
        },

        data() {
            return {
                imageAlt: '',
                alternativeImageAlt: '',
                hasAlternativeImage: true
            };
        },

        computed: {
            isAvailable() {
                return this.availableForSale
            },

            isNew() {
                const created = new Date(this.createdAt);
                const now = new Date(Date.now());
                const difference = created.getTime() - now.getTime();

                const seconds_difference = difference / 1000;
                if (Math.abs(seconds_difference) < 1296000) {
                    return true
                } else {
                    return false
                }
            },

            currentPrice() {
                return format_price(this.priceRange.minVariantPrice.amount * 100, this.currencySymbol, this.currencyIsoCode)
            },

            currentCompareAtPrice() {
                return format_price(this.compareAtPriceRange.minVariantPrice.amount * 100, this.currencySymbol, this.currencyIsoCode)
            },

            isSale() {
                return parseFloat(this.priceRange.minVariantPrice.amount) < parseFloat(this.compareAtPriceRange.minVariantPrice.amount);
            },

            canBeAddedToCart() {
                return this.variantsObj?.edges?.length < 2
            },

            productUrl() {
                return (this.currentLangCode == 'fr') ? `/products/${this.handle}` : `/${this.currentLangCode}/products/${this.handle}`;
            }
        },

        mounted() {
            this.setImage()
            this.setAlternativeImage()
        },

        methods: {
            setImage() {
                this.imageAlt = this.images?.edges[0]?.node?.altText
                const currentSrc =  this.images?.edges[0]?.node?.originalSrc

                if (currentSrc) {
                    const url = this.getResizedImageUrl(currentSrc, IMAGE_WIDTH, IMAGE_HEIGHT)

                    moduleInstance.call('update', null, 'Scroll');

                    lazyLoadImage(this.$refs.image, url, () => {
                        moduleInstance.call('update', null, 'Scroll');
                    })
                }
            },

            setAlternativeImage() {
                if(!this.images?.edges[1] || window.isMobile) {
                    this.hasAlternativeImage = false
                    return false;
                }

                this.hasAlternativeImage = true

                this.alternativeImageAlt = this.images?.edges[1]?.node?.altText

                let currentSrc;

                if(this.customAlternativeImage?.reference?.image?.originalSrc) {
                    currentSrc = this.customAlternativeImage?.reference?.image?.originalSrc;
                } else {
                    currentSrc = this.images?.edges[1]?.node?.originalSrc;
                }

                if (currentSrc) {
                    const url = this.getResizedImageUrl(currentSrc, IMAGE_WIDTH, IMAGE_HEIGHT)

                    moduleInstance.call('update', null, 'Scroll');

                    lazyLoadImage(this.$refs.alternativeImage, url, () => {
                        moduleInstance.call('update', null, 'Scroll');
                        this.$refs?.alternativeImage?.classList.add('-lazy-loaded')
                    })
                }
            },

            getResizedImageUrl(imageUrl, width, height) {
                const splitUrl = imageUrl.split('.')
                const sizeExtension = `_${width}x${height}_crop_center.${splitUrl.pop()}`
                return splitUrl.join('.') + sizeExtension
            },

            onAddToCart() {
                const variantId = this.variantsObj?.edges?.[0]?.node?.id

                if (variantId) {
                    moduleInstance.call(
                        'addToCart',
                        {
                            productGID: variantId,
                            quantity: 1,
                            openCart: true
                        },
                        'Cart'
                    )
                }
            }
        }
    });
}
